module.exports = __webpack_public_path__ + "static/media/om.ab2f9f3c.svg";